

import React from "react";
import './ProductCard.css'
import { useSelector } from 'react-redux'
import {translation} from "../I18n/i18n"

function VerticalCard(props){

  const lang = useSelector(state => state.languageReducer.language)
  
  return(

            <div className="vertical_card">
              <img
                src={props.url}
                alt=""
                className="vertical_card__picture"
              ></img>
              <div className="vertical_card_text">
                <div className='vertical_card_text_flex'>
                  <h2>{props.name}</h2>
                </div>
                <div className="separator_black"></div>
                  <p style={{marginBottom:0}}><span style={{fontWeight:600, fontSize:16}}> {translation(lang,"prix")} : </span><span className='prix'>{props.price}</span></p>
                  {props.initialprice!=''?<p style={{marginBottom:0}}><span style={{fontWeight:600, fontSize:16}} > Original Price : </span><span className='barre'>{props.initialprice}</span></p>:''}
                  <p style={{marginBottom:0}}><span style={{fontWeight:600, fontSize:16,display:props.desc===''?'none':'block'}}>{translation(lang,"dimentions")} (mm) : </span> {props.desc}</p>
                  <p style={{marginBottom:0}}><span style={{fontWeight:600, fontSize:16,display:props.details===''?'none':'block',marginTop:-15}}>Details : </span> {props.details}</p>
                  <p style={{marginBottom:0}}><span style={{fontWeight:600, fontSize:16,display:props.weight===''?'none':'block'}}>{translation(lang,"poids")} (kg) : </span> {props.weight}</p>
              </div>
              <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:100}}>
                <div className="vertical_card_read_more_black">REF : {props.reference}</div>
              </div>
            </div>


        )
  }

  export default VerticalCard;
